module.exports = __webpack_public_path__ + "img/waiting-room.2cf36085.jpg";